import { Button, type ButtonProps, LoadingIndicator } from '@moia-dev/pace-web'

export type LoadingButtonProps = { loading?: boolean } & ButtonProps
export const LoadingButton = ({
  loading,
  disabled,
  icon,
  ...props
}: LoadingButtonProps) => {
  return (
    <Button
      disabled={loading || disabled}
      icon={loading ? <LoadingIndicator /> : icon}
      {...props}
    />
  )
}
